import React, { lazy, Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router';
import PageLoader from '../../@jumbo/components/PageComponents/PageLoader';
import AddCompany from './AddCompany';
import AddContact from './AddContact';
import ListCompany from './ListCompany';
import ListContact from './ListContact';

const Company = ({ match }) => {
  const requestedUrl = match.url.replace(/\/$/, '');
  return (
    <Suspense fallback={<PageLoader />}>
      <Switch>
        <Redirect exact from={`${requestedUrl}/`} to={`${requestedUrl}/listCompanies`} />
        <Route path={`${requestedUrl}/listCompanies`} component={ListCompany} />
        {/* <Route path={`${requestedUrl}/listContact`} component={ListContact} /> */}

        <Route path={`${requestedUrl}/addCompany`} component={AddCompany} />
        {/* <Route path={`${requestedUrl}/addContact`} component={AddContact} /> */}


        <Route component={lazy(() => import('../ExtraPages/404'))} />
      </Switch>
    </Suspense>
  );
};

export default Company;
